<template>
  <v-container class="pa-0 ma-0">
    <v-btn
      fab
      dark
      small
      color="primary"
      @click="onBatchAttachmentCreate"
      :loading="uploading"
    >
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-icon v-on="on">mdi-paperclip</v-icon>
        </template>
        Batch Add Attachment
      </v-tooltip>
    </v-btn>
    <input
      ref="fileChooser"
      accept=".pdf,.doc,.docx,.xls,.jpg,.jpeg,.png"
      type="file"
      style="display: none"
      @change="onFileChange"
    />
  </v-container>
</template>

<script>
import { SIGNED_URL_QUERY } from "../../../constants/graphql";
import gql from "graphql-tag";
const CREATE_ATTACHMENT_MUTATION = gql`
  mutation createAttachments($input: [AttachmentInput!]!) {
    createAttachments(input: $input) {
      name
      owner
      id
      ownerId
    }
  }
`;
export default {
  name: "batch-attachment",
  props: {
    owner: {
      type: String,
      required: true,
      default: () => "",
    },
    items: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data() {
    return {
      uploading: false,
      selectedAttachment: null,
    };
  },
  methods: {
    onBatchAttachmentCreate(event) {
      //console.log("owner", this.owner);
      // Use nextTick to ensure the ref is available, or use event.target
      this.$nextTick(() => {
        if (this.$refs.fileChooser) {
          this.$refs.fileChooser.click();
        }
      });
    },
    onFileChange(event) {
      const files = event.target.files;
      console.log("files", files);
      if (files && files.length > 0) {
        this.uploading = true;
        this.selectedAttachment = files[0];
        console.log("selectedAttachment", this.selectedAttachment);
        this.$apollo
          .query({
            query: SIGNED_URL_QUERY,
            variables: {
              fileName: this.selectedAttachment.name,
            },
          })
          .then(this.putAttachmentToTheBucket, this.handleAttachmentError);
      }
    },
    putAttachmentToTheBucket(result) {
      const response = { ...result.data.signedUrl };
      console.log("result", result);
      console.log("response", response);
      if (response.url) {
        fetch(response.url, {
          method: "PUT",
          body: this.selectedAttachment,
        }).then(this.saveAttachment, this.handleAttachmentError);
      } else {
        this.handleAttachmentError({ message: "Cannot upload the file!" });
      }
    },
    handleAttachmentError(error) {
      this.uploading = false;
      this.$store.dispatch("showAppSnackbar", {
        msg: error.message,
        color: "danger",
      });
    },
    saveAttachment(result) {
      const name = this.selectedAttachment.name;
      const url = result.url;
      console.log("items", this.items);
      const input = this.items.map((item) => ({
        name,
        url,
        owner: this.owner,
        ownerId: item.id,
      }));
      this.$apollo
        .mutate({
          mutation: CREATE_ATTACHMENT_MUTATION,
          variables: {
            input,
          },
        })
        .then(() => {
          this.$store.dispatch("showAppSnackbar", {
            msg: "Attachments created successfully",
            color: "success",
          });
        })
        .catch((error) => {
          this.$store.dispatch("showAppSnackbar", {
            msg: error.message,
            color: "danger",
          });
        })
        .finally(() => {
          this.uploading = false;
        });
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/gt/shared/BatchAttachment.vue